import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Youtube, Instagram, Music2, Mail } from "lucide-react";
import { Separator } from "../../components/ui/separator";
import { useSettings } from "../../contexts/AppContext";

function TiktokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
  );
}

const socialLinks = [
  { key: "social_facebook", Icon: Facebook, label: "Facebook" },
  { key: "social_youtube", Icon: Youtube, label: "YouTube" },
  { key: "social_instagram", Icon: Instagram, label: "Instagram" },
  { key: "social_spotify", Icon: Music2, label: "Spotify" },
  { key: "social_tiktok", Icon: TiktokIcon, label: "TikTok" },
];

export default function Footer() {
  const { shop_enabled, fanclub_enabled, concerts_enabled, ...settings } = useSettings();
  const links = socialLinks.filter(({ key }) => settings[key]);

  return (
    <footer className="bg-card border-t border-white/5 py-12 sm:py-16 pb-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <img src="/assets/images/logo-tz.png" alt="Tajti Zoltán" className="w-10 h-10 sm:w-12 sm:h-12 object-contain" />
              <span className="text-xl sm:text-2xl font-bold font-['Syne']">Tajti Zoltán</span>
            </div>
            <p className="text-muted-foreground text-sm sm:text-base max-w-md leading-relaxed">Sötét pop művész, aki a fény és árnyék határait kutatja.</p>
            {links.length > 0 && (
              <div className="flex gap-4 mt-4 sm:mt-6">
                {links.map(({ key, Icon, label }) => (
                  <a
                    key={key}
                    href={settings[key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 sm:w-10 sm:h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-primary/20 transition-colors"
                    aria-label={label}
                  >
                    <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
                  </a>
                ))}
              </div>
            )}
          </div>
          <div>
            <h4 className="font-bold font-['Syne'] mb-3 sm:mb-4 text-sm sm:text-base">Oldalak</h4>
            <div className="space-y-0 sm:space-y-0 text-sm">
              <Link to="/zene" className="block text-muted-foreground hover:text-white transition-colors">Zene</Link>
              <Link to="/hirek" className="block text-muted-foreground hover:text-white transition-colors">Hírek</Link>
              <Link to="/kapcsolat" className="block text-muted-foreground hover:text-white transition-colors">Kapcsolat</Link>
              {concerts_enabled && <Link to="/koncertek" className="block text-muted-foreground hover:text-white transition-colors">Koncertek</Link>}
              {fanclub_enabled && <Link to="/fan-club" className="block text-muted-foreground hover:text-white transition-colors">Fan Club</Link>}
            </div>
          </div>
          <div>
            <h4 className="font-bold font-['Syne'] mb-3 sm:mb-4 text-sm sm:text-base">Jogi</h4>
            <div className="space-y-0 sm:space-y-0 text-sm">
              <Link to="/adatvedelem" className="block text-muted-foreground hover:text-white transition-colors">Adatvédelem</Link>
              <Link to="/aszf" className="block text-muted-foreground hover:text-white transition-colors">ÁSZF</Link>
            </div>
            <p className="text-muted-foreground text-sm flex items-center gap-2 mt-6"><Mail className="h-4 w-4" />zoltan@ztmusics.hu</p>
          </div>
        </div>
        <Separator className="my-8 sm:my-12 bg-white/5" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs sm:text-sm text-muted-foreground">
          <p>© 2025 Tajti Zoltán. Minden jog fenntartva.</p>
          <div className="flex gap-4 sm:gap-6">
            <Link to="/adatvedelem" className="hover:text-white transition-colors">Adatvédelem</Link>
            <Link to="/aszf" className="hover:text-white transition-colors">ÁSZF</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
